import { generatePath } from 'react-router-dom';

import { apiPaths } from '../config/apiPaths';
import { BorrowDepositDto, BorrowDepositModel } from '../modules/Deposit/model/borrow-deposit-model';
import { DepositRequest } from '../modules/Deposit/model/deposit-request';
import { ReturnDepositDto, ReturnDepositModel } from '../modules/Deposit/model/return-deposit-model';
import { dtoToBorrowDepositModel, dtoToReturnDepositModel } from './mappers/deposit.mappers';
import axios from './axios';

export const borrowDepositItems = async (restaurantId: string, data: DepositRequest): Promise<BorrowDepositModel> => {
  return axios
    .post<BorrowDepositDto>(generatePath(apiPaths.DEPOSIT_BORROW_PATH, { restaurantId }), data)
    .then((response) => dtoToBorrowDepositModel(response.data));
};

export const returnDepositItems = async (restaurantId: string, data: DepositRequest): Promise<ReturnDepositModel> => {
  return axios
    .post<ReturnDepositDto>(generatePath(apiPaths.DEPOSIT_RETURN_PATH, { restaurantId }), data)
    .then((response) => dtoToReturnDepositModel(response.data));
};
